const styles = (theme) => ({
    dialog: {
        '& .MuiDialog-paper': {
            borderRadius: '0px',
            padding: '20px',
            width: 'auto',
            maxWidth: '800px',
        },
    },
    dialogButton: {
        borderRadius: '10px',
        color: theme.palette.primary.main,
        border: `2px solid ${theme.palette.primary.main}`,
        padding: '0',
        textTransform: 'none',
        height: '90px',
        width: '100%',
        minWidth: '250px',
    },
    buttonContent: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
    },
    icon: {
        width: '26px',
        height: '26px',
        marginBottom: '6px',
        color: theme.palette.primary.main,
    },
    buttonText: {
        fontSize: '16px',
        fontWeight: 'bold',
        textAlign: 'center',
        whiteSpace: 'nowrap',
    },
    dialogTitle: {
        color: 'rgba(0, 0, 0, 0.87)',
        position: 'relative',
        textAlign: 'center',
        '& h2': {
            fontWeight: 700,
            fontSize: '24px',
        },
    },
    closeButton: {
        position: 'absolute',
        right: '-5px',
        top: '-5px',
        color: theme.palette.grey[500],
    },
    closeIcon: {
        width: '24px',
        height: '24px',
    },
    dialogContent: {
        padding: '20px',
        width: '100%',
    },
    dialogActions: {
        justifyContent: 'center',
    },
});

export default styles;
